module.exports = __webpack_public_path__ + "static/bruceSiteDemo-988381193cabfe52d9a8f61f946f4959.gif";